import Vue from 'vue'
import VeeValidate from 'vee-validate'
import Cookies from 'js-cookie'
import store from '~/store'
import moment from 'moment'

Vue.use(VeeValidate, { delay: 250 })

VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must contain at least: one english letter and one number`,
  validate: value => {
    var strongRegex = new RegExp('^(?![^a-zA-Z]+$)(?!\\D+$)')
    return strongRegex.test(value)
  }
})

Vue.mixin({
  $_veeValidate: {
    validator: 'new'
  },
  methods: {
    async formHasErrors () {
      const valid = await this.$validator.validateAll()
      if (valid) {
        this.$validator.pause()
      }
      return !valid
    },
    rInfoExpiredAlert () {
      const prefix = window.config.prefix
      if (!Cookies.get(`${prefix}rid`)) {
        store.dispatch('changeTable', '')
        store.dispatch('responseMessage', {
          type: 'error',
          title: this.$t('token_expired_alert_title'),
          text: 'Please re-select outlet',
          modal: true,
          buttons: [
            { text: 'Ok', path: 'outlets' }
          ]
        })
        return true
      }
      return false
    },
    shouldExpireSession () {
      const prefix = window.config.prefix
      if (Cookies.get(`${prefix}visit`) && !store.getters['auth/loginByMemberToken']) {
        let halfAnHourAgo = moment().subtract(30, 'minutes').toDate().getTime()
        if (halfAnHourAgo > Cookies.get(`${prefix}visit`)) {
          return true
        }
      }
      return false
    },
    noTableOrAddressAlert () {
      if (this.noTableAlert()) {
        return true
      } else if (this.noAddressAlert()) {
        return true
      }
      return false
    },
    noTableAlert () {
      if (store.getters['config/mode'].isDinein && store.getters['config/withTableNo'] && store.getters['config/tb'] === '') {
        store.dispatch('dialog/showSettingDialog', 'table')
        return true
      }
      return false
    },
    noAddressAlert () {
      if (store.getters['config/mode'].isDelivery && !store.getters['delivery/isDeliverable']) {
        store.dispatch('dialog/showSettingDialog', 'address')
        return true
      }
      return false
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/validation.js